import type {Container} from 'inversify';
import type {Store} from 'redux';
import {applyMiddleware, compose, createStore} from 'redux';
import {createEpicMiddleware} from 'redux-observable';
import type {RootAction, RootState} from 'typesafe-actions';

import {initEpics} from './rootEpic';
import {createRootReducer} from './rootReducer';

import type {Config} from '@config';

export function initStore(container: Container, config: Config): {store: Store<RootState, RootAction>} {
    const rootEpic = initEpics(container);
    const epicMiddleware = createEpicMiddleware<RootAction, RootAction, RootState>();
    const rootReducer = createRootReducer();
    const composeEnhancers = (config.env === 'DEV' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
    const enhancer = composeEnhancers(applyMiddleware(epicMiddleware));
    const store = createStore(rootReducer, {} as RootState, enhancer);
    epicMiddleware.run(rootEpic);
    return {store: store as Store<RootState, RootAction>};
}
